module.exports = __webpack_public_path__ + "img/dribble-hover.cc68fa94.svg";